var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("\n  p-1 px-2\n  d-" + (_vm.block ? '' : 'inline-') + "block\n  bg-" + _vm.variant + " \n  rounded" + (_vm.pill ? '-xl' : '') + "\n  text-" + _vm.textColor + "\n  ")},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf847670","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/component/badge.vue
// module id = null
// module chunks = 